import { Component, OnInit, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  RunTransition,
  RunTransitionWithDialog,
  WorkflowService,
} from '../../services/workflow/workflow.service';
import { PayeePopupComponent } from '../../payee-popup/payee-popup.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';

type DialogData = {
  transition_label: string;
};

@Component({
  selector: 'app-no-attachment-no-deadline-dialog',
  templateUrl: './no-attachment-no-deadline-dialog.component.html',
  styleUrls: ['./no-attachment-no-deadline-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeButtonComponent,
  ],
})
export class NoAttachmentNoDeadlineDialogComponent implements OnInit {
  private data = inject<RunTransitionWithDialog>(MAT_DIALOG_DATA);
  private dialogRef =
    inject<MatDialogRef<NoAttachmentNoDeadlineDialogComponent>>(MatDialogRef);
  private workflowService = inject(WorkflowService);

  loading = false;
  dialogData?: DialogData;

  readonly form = new FormGroup({});

  async ngOnInit() {
    this.dialogData = (await this.workflowService.getDialogData({
      caseId: this.data.caseId,
      transitionId: this.data.transitionId,
    })) as DialogData;
  }

  readonly onSubmit = async () => {
    if (this.form.invalid) {
      return;
    }

    const closeValue: RunTransition = {
      transitionId: this.data.transitionId,
      caseId: this.data.caseId,
      params: this.data.extraParams,
    };

    this.loading = true;
    try {
      await this.workflowService.runTransition(closeValue);
      this.dialogRef.close(closeValue);
    } catch (error) {
      this.workflowService.showTransitionError(error);
    } finally {
      this.loading = false;
    }
  };

  readonly onCancel = () => {
    this.dialogRef.close();
  };
}
